// Copyright (c) StrangeBee 2024

import ExternalLink from '@Atoms/ExternalLink/ExternalLink';
import { useLocalMessage } from '@Helpers/locale';
import { AlertImport } from '@Molecules/AlertImport/AlertImport';
import { FileImportDrawer } from '@Molecules/FileImportDrawer/FileImportDrawer';
import { THAutoComplete } from '@Molecules/Inputs/THAutoComplete/THAutoComplete';
import React, { ReactElement } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';

import './AttackImport.scss';

interface AttackImportProps {
    onSubmit: (formData: FormData) => Promise<void>;
    thVersion: string;
    dataGroup?: { label: string; value: string }[];

    triggerElem?: ReactElement;
    visible?: boolean;
    onVisibleChange?: (visible: boolean) => void;
}

const AttackImport = ({
    onSubmit,
    thVersion = '4.1.6-1',
    dataGroup = [],
    triggerElem,
    visible,
    onVisibleChange,
}: AttackImportProps): ReactElement => {
    const i = useLocalMessage();
    const [hasCatalog, setHasCatalog] = useState(false);
    const [catalog, setCatalog] = useState('');

    const onSubmitHandler = async (formData: any) => {
        formData.set('_json', JSON.stringify({ catalog }));
        return onSubmit(formData);
    };

    const onChangeHandler = (e: string) => {
        setCatalog(e);
    };

    useEffect(() => {
        setHasCatalog(catalog.length !== 0);
    }, [catalog]);

    return (
        <FileImportDrawer
            onSubmit={onSubmitHandler}
            accept=".json"
            className="attackImport__uploader"
            drawerTitle={i('attackPattern.import.title')}
            preValidate={hasCatalog}
            visible={visible}
            onVisibleChange={onVisibleChange}
            triggerElem={triggerElem}
            header={
                <AlertImport title={i('attackPattern.import.header.title')}>
                    <>
                        {i('attackPattern.import.header.download')}{' '}
                        <ExternalLink
                            url={`https://raw.githubusercontent.com/mitre/cti/master/enterprise-attack/enterprise-attack.json?version=TheHive-${thVersion}`}
                        >
                            enterprise-attack
                        </ExternalLink>
                        ,{' '}
                        <ExternalLink
                            url={`https://raw.githubusercontent.com/mitre/cti/master/mobile-attack/mobile-attack.json?version=TheHive-${thVersion}`}
                        >
                            mobile-attack
                        </ExternalLink>
                    </>
                </AlertImport>
            }
            uploadTitle={i('attackPattern.import.upload.title')}
            footerLabel={i('attackPattern.import.footer')}
        >
            <THAutoComplete
                onChange={onChangeHandler}
                options={dataGroup}
                placeholder="Name of the catalog"
                style={{ margin: '1rem 0', width: '100%' }}
            />
        </FileImportDrawer>
    );
};

export default AttackImport;
